import { render, staticRenderFns } from "./Registered.vue?vue&type=template&id=4d82aa60&scoped=true"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"
import style0 from "./Registered.vue?vue&type=style&index=0&id=4d82aa60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82aa60",
  null
  
)

export default component.exports